import React from 'react';
import InputForm from "../../../../components/input/input-form.jsx";

const InstallerUserStep = ({password, passwordConfirm, onChange}) => (
    <div className={"grid grid-cols-2 gap-4"}>
        <InputForm
            id={"password"}
            type={"password"}
            label={"Senha do administrador (admin)"}
            value={password}
            onChange={onChange}
        />

        <InputForm
            id={"passwordConfirm"}
            type={"password"}
            label={"Confirmação de senha"}
            value={passwordConfirm}
            onChange={onChange}
        />
    </div>
);

export default InstallerUserStep;
